// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS204: Change includes calls to have a more natural evaluation order
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';
import { BaseDirectoryView } from './BaseDirectoryView';
import { DirectoryLegacyPowerUps as directoryLegacyPowerUps } from './DirectoryLegacyPowerUps';
import { DirectoryPluginItemView } from './DirectoryPluginItemView';
import { markdownAsHtml } from 'app/scripts/lib/markdown/format';
import { pluginIOCache } from 'app/scripts/views/internal/plugins/PluginIoCache';
import { PowerUpItemType } from 'app/src/components/PowerUp';
import { recupWithHelpers } from 'app/scripts/views/internal/recupWithHelpers';
const t = recupWithHelpers('directory');
const powerUpItemDetailsT = recupWithHelpers('power_up_item_details');
const c = recupWithHelpers('directory_data_consent');
import notCompliantIcon from 'resources/images/directory/icons/notCompliant.svg';
import compliantIcon from 'resources/images/directory/icons/compliant.svg';
import React from 'react';
import pluginValidators from 'app/scripts/lib/plugins/plugin-validators';
import { applyBidiTooltip } from 'app/src/components/TrelloMarkdown/applyBidiTooltip';

class DirectoryListing extends React.Component {
  static initClass() {
    this.prototype.displayName = 'Directory Listing';

    this.prototype.render = t.renderable(function () {
      const {
        supportEmail,
        description,
        displayName,
        isGrandfathered,
        isCompliant,
        privacyPolicy,
        categories,
        onCategoryClick,
      } = this.props;

      return t.div('.directory-individual-listing', function () {
        t.div('.js-directory-listing');
        if (supportEmail) {
          let supportLink = supportEmail;

          const EMAIL_REGEX = /^[^@]+@[a-z0-9-]+(\.[a-z0-9-]+)+$/i;

          if (EMAIL_REGEX.test(supportLink)) {
            supportLink = `mailto:${supportEmail}?subject=${encodeURIComponent(
              displayName,
            )}`;
          }

          t.div('.directory-listing-support', () =>
            t.div('.support-list', function () {
              t.icon('email', { class: 'icon-lg' });
              t.a('.support-link', { href: supportLink }, () =>
                t.format('contact-support'),
              );
              if (pluginValidators.isValidHttp(privacyPolicy)) {
                t.icon('information', { class: 'icon-lg' });
                return t.a('.support-link', { href: privacyPolicy }, () =>
                  t.format('privacy-policy'),
                );
              }
            }),
          );
        } else {
          t.div('.directory-listing-categories', function () {
            t.icon('information', { class: 'icon-lg' });
            return t.div('.categories-list', () =>
              _.map(categories, (category) =>
                t.a(
                  '.category-link',
                  {
                    href: '#',
                    onClick() {
                      return onCategoryClick(category);
                    },
                  },
                  () => t.format(category),
                ),
              ),
            );
          });
        }

        if (isGrandfathered) {
          t.p('.power-up-grandfathered', function () {
            powerUpItemDetailsT.format(
              'power-up-was-enabled-on-this-board-before-some-recent-changes-we-made',
              {
                name: displayName,
              },
            );
            return t.text(' 🎉');
          });
        }
        t.div(
          '.directory-listing-content.markeddown',
          {
            ref: (node) => {
              if (node) {
                applyBidiTooltip(node);
              }
            },
          },
          () => t.raw(markdownAsHtml(description)),
        );
        return t.div('.directory-listing-compliance', function () {
          const src = isCompliant === false ? notCompliantIcon : compliantIcon;

          c.img('.directory-listing-compliance-icon', {
            src,
            alt: '',
            role: 'presentation',
          });
          if (isCompliant === false) {
            return c.format(
              'power-up-does-not-comply-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          } else if (isCompliant === true) {
            return c.format(
              'power-up-stores-data-complies-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          } else {
            return c.format(
              'power-up-complies-with-our-data-privacy-standards',
              { pluginName: displayName },
            );
          }
        });
      });
    });
  }
}

DirectoryListing.initClass();

class DirectoryListingView extends BaseDirectoryView {
  static initClass() {
    this.prototype.className = 'directory-listing-wrapper';
  }
  eventSource() {
    return 'boardDirectoryPowerUpDetailsScreen';
  }

  initialize({ directoryView, plugin, currentPage }) {
    this.directoryView = directoryView;
    this.plugin = plugin;
    this.currentPage = currentPage;
    super.initialize(...arguments);

    const powerUp = _.findWhere(directoryLegacyPowerUps, {
      id: this.plugin.id,
    });

    if (powerUp) {
      let needle;
      const { name } = powerUp;
      return (this.isGrandfathered =
        ((needle = name),
        Array.from(this.model.get('powerUps')).includes(needle)));
    }
  }

  navigateToCategory(category) {
    return this.directoryView.navigate({ section: 'category', category });
  }

  renderContent() {
    const io = pluginIOCache.get(this.plugin);

    return (
      <DirectoryListing
        displayName={io.getName()}
        description={io.getDescription()}
        supportEmail={this.plugin.get('supportEmail')}
        privacyPolicy={this.plugin.get('privacyUrl')}
        categories={this.plugin.get('categories')}
        isGrandfathered={this.isGrandfathered}
        // eslint-disable-next-line react/jsx-no-bind
        onCategoryClick={(category) => this.navigateToCategory(category)}
        isCompliant={this.plugin.get('isCompliantWithPrivacyStandards')}
        isIntegration={(this.plugin.get('tags') || []).includes('integration')}
      />
    );
  }

  render() {
    super.render(...arguments);

    this.appendSubview(
      this.subview(
        DirectoryPluginItemView,
        this.model,
        {
          atomType: PowerUpItemType.Listing,
          plugin: this.plugin,
          currentPage: this.currentPage,
          directoryView: this.directoryView,
        },
        this.plugin.id,
      ),
      this.$('.js-directory-listing'),
    );

    const enabledPlugins = this.directoryView.getEnabledPlugins();

    this.directoryView.trackScreenEvent(this.eventSource(), {
      powerUpId: this.plugin.id,
      isEnabled: _.some(enabledPlugins, { id: this.plugin.id }) ? true : false,
      tags: this.plugin.get('tags'),
    });

    return this;
  }
}

DirectoryListingView.initClass();
export { DirectoryListingView };
